import { create, v } from '@dojo/framework/core/vdom';
import { icache } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';

import { includes } from 'lodash-es';

import css from '../css/editor.m.css';

interface HeadingSelectProperties {
	value?: string;
	disabled?: boolean;
	title?: string;
	onValue?: (value: string) => void;
}

const factory = create({
	icache,
	theme
}).properties<HeadingSelectProperties>();

const items = [
	{ value: 'div', label: 'Normal' },
	{ value: 'h1', label: 'Heading 1' },
	{ value: 'h2', label: 'Heading 2' },
	{ value: 'h3', label: 'Heading 3' },
	{ value: 'h4', label: 'Heading 4' },
	{ value: 'h5', label: 'Heading 5' },
	{ value: 'h6', label: 'Heading 6' }
];

export const HeadingSelect = factory(({ middleware: { icache, theme }, properties }) => {
	const { value, disabled = false, title, onValue } = properties();

	const values = items.map((i) => i.value);
	const initialValue = includes(values, value) ? value : 'div';
	icache.set('value', initialValue);
	const options = items.map((item) => {
		const { value, label } = item;
		return v('option', { value, selected: initialValue === value }, [label]);
	});

	const { selector } = theme.classes(css);

	return v('div', { classes: [selector, theme.variant()] }, [
		v(
			'select',
			{
				title,
				disabled,
				value: icache.get('value'),
				onchange: (event) => {
					event.preventDefault();
					event.stopPropagation();
					const val = event.target.value;
					icache.set('value', val);
					onValue && onValue(val);
				}
			},
			options
		)
	]);
});

export default HeadingSelect;
